// import React, { useState, useEffect } from 'react';
// import img1 from '../Images/companyimg.webp';
// import img2 from '../Images/com1img.webp';
// import img3 from '../Images/com2.webp';
// import img4 from '../Images/concrete-cover-block-500x500.webp';
// import img5 from '../Images/comp5.webp';

// const Homescreen = () => {
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   const backgroundImages = [img1, img2, img3, img4, img5];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex(
//         (prevIndex) => (prevIndex + 1) % backgroundImages.length
//       );
//     }, 4000);

//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener('resize', handleResize);

//     return () => {
//       clearInterval(interval);
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);

//   return (
//     <div
//       style={{
//         ...styles.safeContainer,
//         ...(isMobile ? styles.safeContainerMobile : {}),
//       }}
//     >
//       <main
//         style={{
//           backgroundImage: `url(${backgroundImages[currentImageIndex]})`,
//           transition: 'background-image 1s ease-in-out',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundRepeat: 'no-repeat',
//           minHeight: '100vh',
//           width: '100%',
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: isMobile ? 'center' : 'flex-start',
//           justifyContent: 'center',
//           padding: isMobile ? '10px' : '20px',
//           boxSizing: 'border-box',
//           textAlign: isMobile ? 'center' : 'left',
//         }}
//       >
//         {/* Example content */}
//         {/* <h1
//           style={{
//             color: '#fff',
//             fontSize: isMobile ? '1.5rem' : '2.5rem',
//             marginBottom: '10px',
//           }}
//         >
//           Welcome to Our Company
//         </h1>
//         <p
//           style={{
//             color: '#fff',
//             maxWidth: isMobile ? '90%' : '600px',
//             fontSize: isMobile ? '0.9rem' : '1.1rem',
//           }}
//         >
//           Delivering quality products with innovation and trust.
//         </p> */}

//       </main>
//     </div>
//   );
// };

// const styles = {
//   safeContainer: {
//     paddingTop: 'env(safe-area-inset-top, 20px)',
//     paddingRight: 'env(safe-area-inset-right, 15px)',
//     paddingBottom: 'env(safe-area-inset-bottom, 20px)',
//     paddingLeft: 'env(safe-area-inset-left, 15px)',
//     minHeight: '100vh',
//     backgroundColor: '#f0f0f0',
//     fontFamily: 'sans-serif',
//     boxSizing: 'border-box',
//   },
//   safeContainerMobile: {
//     paddingTop: 'env(safe-area-inset-top, 10px)',
//     paddingRight: 'env(safe-area-inset-right, 10px)',
//     paddingBottom: 'env(safe-area-inset-bottom, 10px)',
//     paddingLeft: 'env(safe-area-inset-left, 10px)',
//   },
// };

// export default Homescreen;



import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import img1 from '../Images/companyimg.webp';
import img2 from '../Images/com1img.webp';
import img3 from '../Images/com2.webp';
import img4 from '../Images/concrete-cover-block-500x500.webp';
import img5 from '../Images/comp5.webp';

const Homescreen = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isLoaded, setIsLoaded] = useState(false);

  const backgroundImages = [
    img1,
    img2,
    img3,
    img4,
    img5,
  ];

  /* ---------------------------------------
     RESPONSIVE + SLIDER
  --------------------------------------- */

  useEffect(() => {
    setIsLoaded(true);

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (
        (prevIndex + 1) % backgroundImages.length
      ));
    }, 5000);

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  /* ---------------------------------------
     MANUAL SLIDE
  --------------------------------------- */

  const goToSlide = (index) => {
    setCurrentImageIndex(index);
  };

  return (
    <div style={styles.page}>

      {/* =====================================
          HERO SECTION
      ====================================== */}

      <main style={styles.hero}>

        {/* =====================================
            BACKGROUND IMAGE
        ====================================== */}

        <AnimatePresence mode="sync">

          <motion.div
            key={currentImageIndex}
            initial={{
              opacity: 0,
              scale: 1.08,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            exit={{
              opacity: 0,
              scale: 1.02,
            }}
            transition={{
              opacity: {
                duration: 1.2,
              },
              scale: {
                duration: 7,
                ease: 'easeOut',
              },
            }}
            style={{
              ...styles.backgroundImage,
              backgroundImage:
                `url(${ backgroundImages[currentImageIndex]})`,
            }}
          />

        </AnimatePresence>


        {/* =====================================
            IMAGE OVERLAY
        ====================================== */}

        <div style={styles.overlay} />


        {/* =====================================
            DECORATIVE GRID
        ====================================== */}

        <div style={styles.gridOverlay} />


        {/* =====================================
            MAIN CONTENT
        ====================================== */}

        <div
          style={{
            ...styles.contentWrapper,
            ...(isMobile
              ? styles.contentWrapperMobile
              : {}),
          }}
        >

          {/* Small top label */}

          <motion.div
            initial={{
              opacity: 0,
              y: 20,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              delay: 0.3,
              duration: 0.7,
            }}
            style={styles.eyebrow}
          >

            <span style={styles.eyebrowDot} />

            STRUCTGUARD INFRA PRODUCTS & SERVICES LLP

          </motion.div>


          {/* =====================================
              MAIN HEADING
          ====================================== */}

          <AnimatePresence mode="wait">

            <motion.div
              key={currentImageIndex}
              initial={{
                opacity: 0,
                y: 35,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              exit={{
                opacity: 0,
                y: -20,
              }}
              transition={{
                duration: 0.7,
                ease: [0.22, 1, 0.36, 1],
              }}
            >

              <h1
                style={{
                  ...styles.heading,
                  ...(isMobile
                    ? styles.headingMobile
                    : {}),
                }}
              >

                Building
                <span style={styles.orangeText}>
                  {' '}Strength
                </span>

                <br />

                Into Every
                <span style={styles.orangeText}>
                  {' '}Structure.
                </span>

              </h1>


              <p
                style={{
                  ...styles.description,
                  ...(isMobile
                    ? styles.descriptionMobile
                    : {}),
                }}
              >
                High-quality construction products engineered
                for strength, precision and long-lasting
                performance.
              </p>

            </motion.div>

          </AnimatePresence>


          {/* =====================================
              BUTTONS
          ====================================== */}

          <motion.div
            initial={{
              opacity: 0,
              y: 25,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              delay: 0.7,
              duration: 0.7,
            }}
            style={{
              ...styles.buttonGroup,
              ...(isMobile
                ? styles.buttonGroupMobile
                : {}),
            }}
          >

            <motion.button
              whileHover={{
                scale: 1.04,
                boxShadow:
                  '0 15px 35px rgba(242,107,33,0.35)',
              }}
              whileTap={{
                scale: 0.96,
              }}
              style={styles.primaryButton}
              onClick={() => {
                const section =
                  document.getElementById('product');

                if (section) {
                  section.scrollIntoView({
                    behavior: 'smooth',
                  });
                }
              }}
            >

              Explore Products

              <span style={styles.buttonArrow}>
                →
              </span>

            </motion.button>


            <motion.button
              whileHover={{
                scale: 1.04,
                background: 'rgba(255,255,255,0.16)',
              }}
              whileTap={{
                scale: 0.96,
              }}
              style={styles.secondaryButton}
              onClick={() => {
                const section =
                  document.getElementById('about');

                if (section) {
                  section.scrollIntoView({
                    behavior: 'smooth',
                  });
                }
              }}
            >

              Discover More

            </motion.button>

          </motion.div>

        </div>


        {/* =====================================
            FLOATING INFO CARD
        ====================================== */}

        {!isMobile && (

          <motion.div
            initial={{
              opacity: 0,
              x: 50,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              delay: 1,
              duration: 0.8,
            }}
            style={styles.floatingCard}
          >

            <div style={styles.floatingIcon}>
              ✓
            </div>

            <div>

              <div style={styles.floatingTitle}>
                Quality Focused
              </div>

              <div style={styles.floatingSubtitle}>
                Engineered for performance
              </div>

            </div>

          </motion.div>

        )}


        {/* =====================================
            BOTTOM STATS
        ====================================== */}

        {!isMobile && (

          <motion.div
            initial={{
              opacity: 0,
              y: 30,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              delay: 1.1,
              duration: 0.8,
            }}
            style={styles.statsContainer}
          >

            <Stat
              number="100%"
              label="Quality Focus"
            />

            <div style={styles.statDivider} />

            <Stat
              number="15+"
              label="Years Experience"
            />

            <div style={styles.statDivider} />

            <Stat
              number="500+"
              label="Projects Supported"
            />

          </motion.div>

        )}


        {/* =====================================
            SLIDER CONTROLS
        ====================================== */}

        <div
          style={{
            ...styles.sliderControls,
            ...(isMobile
              ? styles.sliderControlsMobile
              : {}),
          }}
        >

          {backgroundImages.map((_, index) => (

            <motion.button
              key={index}
              onClick={() => goToSlide(index)}
              whileHover={{
                scale: 1.15,
              }}
              whileTap={{
                scale: 0.9,
              }}
              style={{
                ...styles.sliderDot,
                ...(currentImageIndex === index
                  ? styles.sliderDotActive
                  : {}),
              }}
              aria-label={`Go to slide ${ index + 1 } `}
            />

          ))}

        </div>


        {/* =====================================
            SCROLL INDICATOR
        ====================================== */}

        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            delay: 1.5,
          }}
          style={styles.scrollIndicator}
        >

          <div style={styles.scrollMouse}>

            <motion.div
              animate={{
                y: [0, 7, 0],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
              }}
              style={styles.scrollWheel}
            />

          </div>

          {/* <span>
            SCROLL TO EXPLORE
          </span> */}

        </motion.div>


        {/* =====================================
            SLIDE NUMBER
        ====================================== */}

        <div style={styles.slideNumber}>

          <span style={styles.slideCurrent}>
            {String(currentImageIndex + 1).padStart(2, '0')}
          </span>

          <span style={styles.slideSlash}>
            /
          </span>

          <span>
            {String(backgroundImages.length).padStart(2, '0')}
          </span>

        </div>

      </main>

    </div>
  );
};


/* =========================================
   STAT COMPONENT
========================================= */

const Stat = ({ number, label }) => {

  return (
    <motion.div
      whileHover={{
        y: -4,
      }}
      style={styles.stat}
    >

      <div style={styles.statNumber}>
        {number}
      </div>

      <div style={styles.statLabel}>
        {label}
      </div>

    </motion.div>
  );
};


/* =========================================
   INLINE STYLES
========================================= */

const styles = {

  page: {
    width: '100%',
    minHeight: '100vh',
    overflow: 'hidden',

    fontFamily:
      'Inter, Arial, Helvetica, sans-serif',

    background: '#111',
  },


  /* ---------------------------------------
     HERO
  --------------------------------------- */

  hero: {
    position: 'relative',

    width: '100%',
    height: '100vh',

    minHeight: '650px',

    overflow: 'hidden',

    display: 'flex',
    alignItems: 'center',
  },


  /* ---------------------------------------
     BACKGROUND
  --------------------------------------- */

  backgroundImage: {
    position: 'absolute',

    inset: 0,

    width: '100%',
    height: '100%',

    backgroundSize: 'cover',
    backgroundPosition: 'center',

    backgroundRepeat: 'no-repeat',

    zIndex: 0,
  },


  /* ---------------------------------------
     DARK GRADIENT
  --------------------------------------- */

  overlay: {
    position: 'absolute',

    inset: 0,

    zIndex: 1,

    background:
      'linear-gradient(90deg, rgba(10,17,22,0.90) 0%, rgba(10,17,22,0.68) 38%, rgba(10,17,22,0.22) 75%, rgba(10,17,22,0.40) 100%)',
  },


  /* ---------------------------------------
     GRID
  --------------------------------------- */

  gridOverlay: {
    position: 'absolute',

    inset: 0,

    zIndex: 2,

    opacity: 0.13,

    backgroundImage:
      'linear-gradient(rgba(255,255,255,0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.15) 1px, transparent 1px)',

    backgroundSize: '70px 70px',

    pointerEvents: 'none',
  },


  /* ---------------------------------------
     CONTENT
  --------------------------------------- */

  contentWrapper: {
    position: 'relative',

    zIndex: 5,

    width: '100%',

    maxWidth: '1250px',

    margin: '0 auto',

    padding:
      '100px 70px 80px 70px',

    boxSizing: 'border-box',
  },


  contentWrapperMobile: {
    padding:
      '100px 24px 100px 24px',

    textAlign: 'center',

    display: 'flex',

    flexDirection: 'column',

    alignItems: 'center',

    justifyContent: 'center',
  },


  /* ---------------------------------------
     EYEBROW
  --------------------------------------- */

  eyebrow: {
    display: 'inline-flex',

    alignItems: 'center',

    gap: '9px',

    padding:
      '8px 14px',

    marginBottom: '20px',

    border:
      '1px solid rgba(255,255,255,0.25)',

    borderRadius: '50px',

    background:
      'rgba(255,255,255,0.08)',

    backdropFilter: 'blur(8px)',

    color: '#ffffff',

    fontSize: '11px',

    fontWeight: '600',

    letterSpacing: '1.5px',
  },


  eyebrowDot: {
    width: '7px',
    height: '7px',

    borderRadius: '50%',

    background: '#f26b21',

    boxShadow:
      '0 0 12px rgba(242,107,33,0.9)',
  },


  /* ---------------------------------------
     HEADING
  --------------------------------------- */

  heading: {
    margin: 0,

    color: '#ffffff',

    fontSize: 'clamp(48px, 6vw, 82px)',

    lineHeight: '1.02',

    letterSpacing: '-3px',

    fontWeight: '800',

    maxWidth: '850px',
  },


  headingMobile: {
    fontSize: 'clamp(40px, 12vw, 60px)',

    lineHeight: '1.04',

    letterSpacing: '-2px',
  },


  orangeText: {
    color: '#f26b21',
  },


  /* ---------------------------------------
     DESCRIPTION
  --------------------------------------- */

  description: {
    color:
      'rgba(255,255,255,0.78)',

    fontSize: '17px',

    lineHeight: '1.7',

    maxWidth: '590px',

    margin:
      '24px 0 30px 0',
  },


  descriptionMobile: {
    fontSize: '15px',

    lineHeight: '1.65',

    maxWidth: '450px',

    margin:
      '20px auto 28px auto',
  },


  /* ---------------------------------------
     BUTTONS
  --------------------------------------- */

  buttonGroup: {
    display: 'flex',

    alignItems: 'center',

    gap: '14px',
  },


  buttonGroupMobile: {
    flexDirection: 'column',

    width: '100%',

    maxWidth: '320px',

    gap: '11px',
  },


  primaryButton: {
    border: 'none',

    padding:
      '15px 23px',

    borderRadius: '8px',

    background:
      'linear-gradient(135deg, #f26b21, #ff8a4c)',

    color: '#ffffff',

    fontSize: '14px',

    fontWeight: '700',

    cursor: 'pointer',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    gap: '14px',

    boxShadow:
      '0 10px 25px rgba(242,107,33,0.25)',
  },


  buttonArrow: {
    fontSize: '19px',

    lineHeight: 1,
  },


  secondaryButton: {
    padding:
      '14px 23px',

    borderRadius: '8px',

    border:
      '1px solid rgba(255,255,255,0.4)',

    background:
      'rgba(255,255,255,0.08)',

    backdropFilter: 'blur(8px)',

    color: '#ffffff',

    fontSize: '14px',

    fontWeight: '600',

    cursor: 'pointer',
  },


  /* ---------------------------------------
     FLOATING CARD
  --------------------------------------- */

  floatingCard: {
    position: 'absolute',

    right: '60px',
    top: '32%',

    zIndex: 6,

    display: 'flex',

    alignItems: 'center',

    gap: '12px',

    padding:
      '13px 18px',

    borderRadius: '12px',

    background:
      'rgba(255,255,255,0.11)',

    border:
      '1px solid rgba(255,255,255,0.22)',

    backdropFilter: 'blur(15px)',

    color: '#ffffff',

    boxShadow:
      '0 15px 40px rgba(0,0,0,0.18)',
  },


  floatingIcon: {
    width: '34px',
    height: '34px',

    borderRadius: '50%',

    display: 'flex',

    alignItems: 'center',
    justifyContent: 'center',

    background: '#f26b21',

    color: '#fff',

    fontWeight: '800',
  },


  floatingTitle: {
    fontSize: '13px',

    fontWeight: '700',

    marginBottom: '3px',
  },


  floatingSubtitle: {
    fontSize: '10px',

    color:
      'rgba(255,255,255,0.65)',
  },


  /* ---------------------------------------
     STATS
  --------------------------------------- */

  statsContainer: {
    position: 'absolute',

    left: '70px',
    bottom: '45px',

    zIndex: 6,

    display: 'flex',

    alignItems: 'center',

    gap: '24px',

    color: '#ffffff',
  },


  stat: {
    cursor: 'default',
  },


  statNumber: {
    fontSize: '22px',

    fontWeight: '800',

    color: '#ffffff',
  },


  statLabel: {
    fontSize: '10px',

    marginTop: '3px',

    color:
      'rgba(255,255,255,0.60)',

    letterSpacing: '0.5px',
  },


  statDivider: {
    width: '1px',

    height: '30px',

    background:
      'rgba(255,255,255,0.25)',
  },


  /* ---------------------------------------
     SLIDER DOTS
  --------------------------------------- */

  sliderControls: {
    position: 'absolute',

    right: '70px',
    bottom: '55px',

    zIndex: 10,

    display: 'flex',

    alignItems: 'center',

    gap: '8px',
  },


  sliderControlsMobile: {
    right: '50%',

    transform: 'translateX(50%)',

    bottom: '38px',
  },


  sliderDot: {
    width: '7px',
    height: '7px',

    padding: 0,

    border: 'none',

    borderRadius: '50%',

    background:
      'rgba(255,255,255,0.45)',

    cursor: 'pointer',

    transition:
      'all 0.25s ease',
  },


  sliderDotActive: {
    width: '28px',

    borderRadius: '10px',

    background: '#f26b21',

    boxShadow:
      '0 0 10px rgba(242,107,33,0.55)',
  },


  /* ---------------------------------------
     SCROLL
  --------------------------------------- */

  scrollIndicator: {
    position: 'absolute',

    right: '27px',
    top: '50%',

    transform:
      'translateY(-50%)',

    zIndex: 6,

    display: 'flex',

    flexDirection: 'column',

    alignItems: 'center',

    gap: '10px',

    color:
      'rgba(255,255,255,0.6)',

    fontSize: '8px',

    letterSpacing: '1.5px',

    writingMode: 'vertical-rl',
  },


  scrollMouse: {
    width: '19px',
    height: '31px',

    border:
      '1px solid rgba(255,255,255,0.5)',

    borderRadius: '12px',

    display: 'flex',

    justifyContent: 'center',

    paddingTop: '5px',

    boxSizing: 'border-box',
  },


  scrollWheel: {
    width: '3px',
    height: '6px',

    borderRadius: '5px',

    background: '#f26b21',
  },


  /* ---------------------------------------
     SLIDE NUMBER
  --------------------------------------- */

  slideNumber: {
    position: 'absolute',

    right: '70px',
    top: '120px',

    zIndex: 6,

    color:
      'rgba(255,255,255,0.55)',

    fontSize: '12px',

    letterSpacing: '2px',
  },


  slideCurrent: {
    color: '#ffffff',

    fontWeight: '700',
  },


  slideSlash: {
    margin:
      '0 6px',

    color: '#f26b21',
  },

};

export default Homescreen;
